
    import Component from "vue-class-component";
    import {Prop} from "vue-property-decorator";
    import {
        ApplicationActions,
        EditDocumentSeedRequest,
        EditFastFerryMasterCertificateSeedRequest,
        ResultError,
        AreasClient,
        FastFerryMasterCertificateDocumentApiModel,
        AreaOption,
        ShipsClient,
        ShipOption
    } from "@/api-client";
    import IssueDocumentInnerComponent from "@/features/applications/components/issue-document/IssueDocumentInnerComponent";
    import IssueDocumentSignature from "@/features/applications/components/issue-document/IssueDocumentSignature.vue";
    import DatePicker from "@/components/DatePicker.vue";
    import LabelOptional from "@/features/shared/components/LabelOptional.vue";
    import AdditionalInfoButton from "@/features/shared/components/AdditionalInfoButton.vue";
    import Multiselect from "vue-multiselect";

    @Component({
        components: {
            AdditionalInfoButton,
            DatePicker,
            IssueDocumentSignature,
            LabelOptional,
            Multiselect
        }
    })
    export default class IssueFastFerryMasterCertificate extends IssueDocumentInnerComponent {
        @Prop({required: true})
        issueDocumentDetails!: FastFerryMasterCertificateDocumentApiModel;
        @Prop({required: true})
        actions!: ApplicationActions;
        @Prop({required: true})
        errors!: ResultError;

        initialEditModel!: EditDocumentSeedRequest;
        areasClient = new AreasClient();
        shipsClient = new ShipsClient();

        validUntil = this.issueDocumentDetails.validUntil;
        issueDate = this.issueDocumentDetails.issueDate;
        additionalInfo = this.issueDocumentDetails.additionalInfo;
        selectedShips: ShipOption[] = [];
        selectedShippingLines: AreaOption[] = [];
        shipOptions: ShipOption[] = [];
        shippingLineOptions: AreaOption[] = [];

        async mounted() {
            await this.loadShips();
            await this.loadShippingLines();
            await this.prefillIssueDateFromQualification();

            // Initialize selected ships from existing data after options are loaded
            if (this.issueDocumentDetails.shipIds && this.issueDocumentDetails.shipIds.length > 0) {
                this.selectedShips = this.shipOptions.filter(option =>
                    this.issueDocumentDetails.shipIds.includes(option.value)
                );
            }

            // Initialize selected shipping lines from existing data after options are loaded
            if (this.issueDocumentDetails.shippingLineIds && this.issueDocumentDetails.shippingLineIds.length > 0) {
                this.selectedShippingLines = this.shippingLineOptions.filter(option =>
                    this.issueDocumentDetails.shippingLineIds.includes(option.value)
                );
            }

            this.initialEditModel = this.getEditModel();
        }

        async loadShips() {
            const response = await this.shipsClient.shipOptions();
            this.shipOptions = response.ships;
        }

        async loadShippingLines() {
            const response = await this.areasClient.shippingLineOptions();
            this.shippingLineOptions = response.areas;
        }

        async prefillIssueDateFromQualification() {
            // Pre-fill issue date from qualification requirement if not already set
            if (!this.issueDate) {
                // TODO: Query application qualification requirement and extract IssuedOn date
                // For now, use current date as default
                this.issueDate = new Date();
            }
        }

        getEditModel(): EditDocumentSeedRequest {
            const request = new EditFastFerryMasterCertificateSeedRequest();
            request.additionalInfo = this.additionalInfo;
            request.issueDate = this.issueDate;
            request.validUntil = this.validUntil;
            // Extract just the IDs from the selected ships and shipping lines
            request.shipIds = this.selectedShips.map(ship => ship.value);
            request.shippingLineIds = this.selectedShippingLines.map(line => line.value);
            return request;
        }
    }
